import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from "typedjson";
import { PitActivityEntityLink } from "./pit-activity-entity-link";
import { PitActivityEntityInvertLink } from "./pit-activity-entity-invert-link";
/** Мероприятие */
let PitActivity = class PitActivity {
    /** Мероприятие */
    constructor() {
        /** Ссылки на связанные мероприятия */
        this._entityLinks = [];
        this._entityInvertLinks = [];
    }
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get code() {
        return this._code;
    }
    set code(value) {
        this._code = value;
    }
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    get description() {
        return this._description;
    }
    set description(value) {
        this._description = value;
    }
    get typeId() {
        return this._typeId;
    }
    set typeId(value) {
        this._typeId = value;
    }
    get curatorId() {
        return this._curatorId;
    }
    set curatorId(value) {
        this._curatorId = value;
    }
    get isFinished() {
        return this._isFinished;
    }
    set isFinished(value) {
        this._isFinished = value;
    }
    get finishDate() {
        return this._finishDate;
    }
    set finishDate(value) {
        this._finishDate = value;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(value) {
        this._isDeleted = value;
    }
    get shortName() {
        return this._shortName;
    }
    set shortName(value) {
        this._shortName = value;
    }
    get subjectAreaId() {
        return this._subjectAreaId;
    }
    set subjectAreaId(value) {
        this._subjectAreaId = value;
    }
    get entityLinks() {
        return this._entityLinks;
    }
    set entityLinks(value) {
        this._entityLinks = value;
    }
    get entityInvertLinks() {
        return this._entityInvertLinks;
    }
    set entityInvertLinks(value) {
        this._entityInvertLinks = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivity.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "code", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitActivity.prototype, "_code", void 0);
tslib_1.__decorate([
    jsonMember({ name: "name", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitActivity.prototype, "_name", void 0);
tslib_1.__decorate([
    jsonMember({ name: "shortName", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitActivity.prototype, "_shortName", void 0);
tslib_1.__decorate([
    jsonMember({ name: "description", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitActivity.prototype, "_description", void 0);
tslib_1.__decorate([
    jsonMember({ name: "typeId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivity.prototype, "_typeId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "curatorId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivity.prototype, "_curatorId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "isFinished", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], PitActivity.prototype, "_isFinished", void 0);
tslib_1.__decorate([
    jsonMember({ name: "finishDate", constructor: Date, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], PitActivity.prototype, "_finishDate", void 0);
tslib_1.__decorate([
    jsonMember({ name: "isDeleted", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], PitActivity.prototype, "_isDeleted", void 0);
tslib_1.__decorate([
    jsonMember({ name: "subjectAreaId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivity.prototype, "_subjectAreaId", void 0);
tslib_1.__decorate([
    jsonArrayMember(PitActivityEntityLink, { name: "entityLinks", emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], PitActivity.prototype, "_entityLinks", void 0);
tslib_1.__decorate([
    jsonArrayMember(PitActivityEntityInvertLink, { name: "entityInvertLinks", emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], PitActivity.prototype, "_entityInvertLinks", void 0);
PitActivity = tslib_1.__decorate([
    jsonObject
], PitActivity);
export { PitActivity };
